<template>
  <div class="title"></div>
</template>
<script>
export default {
	created(){
		this.isMobile();
	},
  methods: {
    isMobile() {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        //alert(navigator.userAgent);
        // setTimeout(() =>window.open("https://www.baidu.com/", "_blank"));
		window.location.href="https://apps.apple.com/cn/app/mei-tuan-wai-mai/id737310995"
      } else if (/(android)/i.test(navigator.userAgent)) {
        //alert(navigator.userAgent);
		window.location.href="http://172.20.10.2:8083/user/downloadFile"
} else {
		alert("请使用手机扫码下载！")
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  color: #000000;
}
</style>



// WEBPACK FOOTER //
// src/components/merchantDownload.vue